import { connect } from 'react-redux'
import SchoolDetailsSubFT from './school-details-sub-ft'
import { withRouter } from 'react-router-dom'
import { getSchool } from '../../../../stores/schools/schools.selectors'
import { assignSchoolFT } from '../../../../stores/school/school.actions'
import { toast } from 'pobble-components/dist/toast'

const mapStateToProps = state => {
  const school = getSchool(state)
  return {
    id: school.id,
    subscriptionIds: school && school.subscription_ids
  }
}

const mapDispatchToProps = (dispatch, { match }) => ({
  onSubmit: values => {
    const data = {
      contact_email_address: values.contactEmailAddress,
      finance_contact: values.financeContactAddress,
      plan_type: values.plan,
      price: values.price
    }
    dispatch(assignSchoolFT(match.params.id, data))
      .then(toast.success('Free-trial successfully added'))
      .catch(e =>
        toast.error(
          (e.response.data.errors && e.response.data.errors[0].msg) ||
            'Something went wrong'
        )
      )
  }
})

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(SchoolDetailsSubFT)
)
